import getCalendarPickerStore from '../selectors/getCalendarPickerStore';
import type CalendarPickerScenarioId from '../store/schema/CalendarPickerScenarioId';
import type { CalendarPickerItemDragData } from '../store/schema/CalendarPickerItemDragData';

export default function getDraggedItemData(
    scenarioId: CalendarPickerScenarioId
): CalendarPickerItemDragData {
    return getCalendarPickerStore(scenarioId).draggedItemData;
}
